import { constants } from "../constant/constants";
import { HttpHelper } from "../helper/http-helper-service";
import { invoicePaginationObject } from "../model/invoice/invoice-response-model";

export default class billingService {
    constructor() {
    }

    static getInvoiceById = (invoiceid: string) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getInvoiceById + "/" + invoiceid);
    }

    static getInvoice = (pagination: invoicePaginationObject) => {
        return HttpHelper.postData(constants.apiUrl.billingUrls.getInvoice, pagination);
    }

    static getInvoicesByTick = (obj: any) => {
        return HttpHelper.postData(constants.apiUrl.billingUrls.getInvoicesByTick, obj);
    }

    static downloadInvoice = (params: any, invoiceNumber: string) => {
        return HttpHelper.postDataToGetFile(constants.apiUrl.billingUrls.downloadInvoice, params, invoiceNumber);
    }

    static getInvoiceListById = (id: string) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getInvoiceListById + "/" + id, {});
    }

    static getPublicXeroLink = (externalInvoiceId: string) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getPublicXeroLink + "/" + externalInvoiceId, {});
    }

    static getInvoiceCurrency = (apiCallAbortSignal: AbortSignal | undefined = undefined) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getInvoiceCurrency, null);
    }

    static getContracts = (obj: any) => {
        return HttpHelper.postData(constants.apiUrl.billingUrls.getContracts, obj);
    }
}
